import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Task } from '../../model/task.model';
import { User } from '../../model/user.model';
import GenericInfo, { InfoField } from '../../Component/adminScreen/GenericInfo';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import CircleIcon from '@mui/icons-material/Circle';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
import { updateTask, setAllTask } from '../../Redux/tasx/taskAction';
import { UpDateTask, getAllTaskFromServer, deleteTask } from '../../api/task.api';
// import {setAllTasks} from "../../"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
// import  {fetchDataTask} from "./tasks.component"
import styles from './TaskInfo.module.css';

interface Props {
  selectedTaskId: string;
  refresh: any
  onClose?: () => void
}

const TaskInfo: React.FC<Props> = ({ selectedTaskId, refresh, onClose }) => {
  const dispatch = useDispatch();
  const [currentTask, setCurrentTask] = useState<Task | null>(null);
  const tasks = useSelector((state: { Task: { allTask: Task[] } }) => state.Task.allTask);
  const users = useSelector((state: { user: { allUser: User[] } }) => state.user.allUser);
  const selectedTask = tasks.find(t => t.taskId === selectedTaskId) || null;
  const statuses = useSelector((state: any) => state.taskStatus.allTaskStatus);




  useEffect(() => {
    console.log("statuses", statuses);
    const fetchTasks = async () => {
      if (!tasks || tasks.length === 0) {
        try {


          const fetchedTasks = await getAllTaskFromServer();
          dispatch(setAllTask(fetchedTasks));
        } catch (error) {
          console.error('Error fetching tasks:', error);
        }
      }
    };

    fetchTasks();
  }, [dispatch, tasks]);
  useEffect(() => {
    console.log("selectedTaskId", selectedTaskId); // הדפסה ברגע שה-ID משתנה
  }, [selectedTaskId]);
  useEffect(() => {
    const updatedSelectedTask = tasks.find(t => t.taskId === selectedTaskId) || null;
    setCurrentTask(updatedSelectedTask);
  }, [selectedTaskId, tasks]);

  if (!currentTask) return null;

  const handleFieldsUpdate = (updatedFields: InfoField[]) => {
    if (!currentTask) return;

    const updatedTask = { ...currentTask };
    updatedFields.forEach(field => {
      if (field.fieldName) {
        // המרת תאריך חזרה לפורמט Date אם נדרש
        // if (field.fieldName === 'startDate' && typeof field.value === 'string') {
        //   updatedTask[field.fieldName] = new Date(field.value);
        // } else {
        updatedTask[field.fieldName] = field.value;

      }
    });

    setCurrentTask(updatedTask);
  };

  const convertDateToDisplay = (date: any): string => {
    if (!date) return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const formatDateForInput = (dateStr: Date | string): string => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0]; // YYYY-MM-DD
  };

  const onSubmit = async (updatedData: Partial<Task>) => {
    if (!currentTask) return;
    try {
      onClose()
      const processedData = { ...updatedData };
      if (processedData.status && typeof processedData.status === 'object') {
        const fullStatusObject = statuses.find((status: { id: string }) => status.id === processedData.status.value);
        processedData.status = fullStatusObject || processedData.status; // 🔹 שמירת האובייקט המלא
      }

      const updatedTask = { ...currentTask, ...processedData };
      const result = await UpDateTask(updatedTask);

      console.log("🔹 נתונים שנשלחו לשרת:", processedData);

      setCurrentTask(result);
      const updatedTasks = tasks.map(t =>
        t.taskId === updatedTask.taskId ? updatedTask : t
      );
      Swal.fire({
        title: 'הצלחה!',
        text: 'המשימה נשמרה בהצלחה',
        icon: 'success',
        confirmButtonText: 'אוקיי'
      });
      dispatch(setAllTask(updatedTasks));
      refresh()
    } catch (err) {
      console.error('❌ שגיאה בעדכון המשימה:', err);
    }
  };
  const handleDeleteTask = async () => {
    onClose()
    const result = await Swal.fire({
      title: 'האם אתה בטוח?',
      text: 'לא תוכל לשחזר את המשימה לאחר המחיקה!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'מחק',
      cancelButtonText: 'ביטול', customClass: {
        popup: 'zindex-override'
      }
    });
    if (result.isConfirmed && currentTask) {
      try {
        await deleteTask(currentTask.taskId);
        refresh()
        Swal.fire('נמחק!', ' נמחק בהצלחה', 'success');
        const updatedTask = tasks.filter(t => t.taskId !== currentTask.taskId);
        dispatch(setAllTask(updatedTask));
      } catch (error) {
        console.error('מחיקת משימה נכשלה:', error);
        Swal.fire('שגיאה', 'אירעה שגיאה בעת המחיקה', 'error');
      }
    }
  };
  // פונקציה לקבלת תווית המשתמש
  const getUserLabel = (userId: string): string => {
    const user = users.find(u => u.id === userId);
    return user ? `${user.firstName} ${user.lastName}` : userId;
  };

  // פונקציה לקבלת תווית רמת הדחיפות
  const getUrgencyLabel = (level: string): { label: string; icon: React.ReactNode } => {
    const urgencyOptions = [
      { value: '1', icon: <CircleIcon style={{ color: 'green' }} />, label: 'נמוכה' },
      { value: '2', icon: <PlayArrowRoundedIcon style={{ color: 'lightblue' }} />, label: 'בינונית' },
      { value: '3', icon: <StarRoundedIcon style={{ color: 'yellow' }} />, label: 'גבוהה' },
      { value: '4', icon: <AssistantPhotoIcon style={{ color: 'red' }} />, label: 'דחופה מאוד' },
    ];

    const option = urgencyOptions.find(opt => opt.value === level);
    return option || { label: level, icon: null };
  };

  const fields: InfoField[] = [
    {
      label: 'אחראית',
      fieldName: 'assignedTo',
      value: currentTask.assignedTo,
      editType: 'icon-select',
      options: users.map(user => ({
        value: user.id,
        label: `${user.firstName} ${user.lastName}`,
        icon: <AccountCircleOutlinedIcon />, // הוספת אייקון למשתמשים
      })),
    },
    {
      label: 'רמת דחיפות',
      value: currentTask.levelUrgencyStatus,
      fieldName: 'levelUrgencyStatus',
      editType: 'icon-select',
      options: [
        { value: '1', icon: <CircleIcon style={{ color: 'green' }} />, label: 'נמוכה' },
        { value: '2', icon: <PlayArrowRoundedIcon style={{ color: 'lightblue' }} />, label: 'בינונית' },
        { value: '3', icon: <StarRoundedIcon style={{ color: 'yellow' }} />, label: 'גבוהה' },
        { value: '4', icon: <AssistantPhotoIcon style={{ color: 'red' }} />, label: 'דחופה מאוד' },
      ],
    },
    {
      label: 'תאריך התחלה',
      fieldName: 'startDate',
      value: formatDateForInput(currentTask.startDate),
      editType: 'date',
    },
    {
      label: 'סטטוס משימה',
      fieldName: 'status',
      value: currentTask.status?.value || '',
      editType: 'status-select',
      options: statuses.map((status: { id: string; value: string }) => ({
        value: status.id,
        label: status.value, // הצגת שם הסטטוס
      })),
    },

    {
      label: 'משך זמן בימים',
      fieldName: 'expectedDurationInDays',
      value: currentTask.expectedDurationInDays,
      editType: 'number',

    },

  ];

  return (
    <div style={{ width: "100%" }}>
      <GenericInfo
        title={currentTask.taskName}
        fields={fields}
        onSubmit={onSubmit}
        onFieldsUpdate={handleFieldsUpdate}
        fieldsContainerClassName={styles.horizontalFields}
        onDelete={handleDeleteTask}
      />
    </div>
  );
};

export default TaskInfo;